
class CurrencyAllController {
    /*@ngInject*/
    constructor(Auth, $state, User, CurrencyService, Modal, $translate, $stateParams, $location) {
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.Service = CurrencyService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;

        this.loading = true;
        this.currencies = [];
        this.hasACL = {};
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10;
        this.searchText = '';
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page;
        if (pageId > 0) {
            this.page = pageId;
        }
        this.loadData();
    }

    edit(currency) {
        this.$state.go('currency.edit', {
            id: currency.id
        });
    }

    delete(currency) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${currency.id}</strong>?`,
            callback: (({ modal, $scope }) => {
                $scope.loading = true;
                this.Service.remove(currency.id)
                    .then((data) => {
                        this.allowOnlyOnce = false;
                        modal.close();
                        this.refresh();
                    })
                    .catch((err) => {
                        this.allowOnlyOnce = false;
                        modal.close();
                        this.Modal.errorModal(err.data.message);
                    });
            }),
            negative: (({ modal }) => {
                this.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        });
    }

    refresh() {
        this.loadData();
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    generateSearchObj() {
        return {
            queryText: '%' + this.searchText + '%',
            isQuery: false
        };
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    // Load All Currencies
    loadData() {
        const searchObj = this.generateSearchObj();

        this.loading = true;
        this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
            .then((data) => {
                this.total = data.total;
                this.currencies = data.results;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                this.error = err.message;
            });
    }
}

export default CurrencyAllController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/all/currency.all.controller.js